import { Theme } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles } from '@material-ui/styles';

const useStyle = makeStyles((theme: Theme) => ({
    root: {
        color: theme.palette.secondary.main
    }
}));

const IconCheck = () => {
    const classes = useStyle();

    return <CheckIcon className={classes.root} />
}

export default IconCheck;